import { MarkdownReact } from "@/components/MarkdownReact";
import { TaskDescriptionTable } from "./TaskDescriptionTable";

interface ThreadTaskDescriptionProps {
  description: string;
}

/** Renders the full task instructions inline, under its task row. */
export function ThreadTaskDescription({
  description,
}: ThreadTaskDescriptionProps) {
  return (
    <div className="pb-2 pl-7 pr-2">
      <div className="prose prose-sm max-w-none break-words text-[13px] leading-relaxed text-muted-foreground dark:prose-invert prose-headings:mb-2 prose-headings:mt-3 prose-p:my-2 prose-ul:my-2 prose-ol:my-2 prose-li:my-0.5 prose-pre:whitespace-pre-wrap [&_a]:break-all">
        <MarkdownReact components={{ table: TaskDescriptionTable }}>
          {description}
        </MarkdownReact>
      </div>
    </div>
  );
}
